import { observer } from "mobx-react";
import { LoanDetailsCardProps } from "../../summary/summaryStep";
import { formatPercentage } from "@roc/ui/utils";
import { LoanDetailsCardSingleProperty } from "./loanDetailsCardSingleProperty";

export const SinglePropertyRentalLoanDetailsCard = observer(
  ({ store }: LoanDetailsCardProps) => {
    const leverage = store.loanEconomicsStore.getLoanEconomics();
    const calculatedFields = store.loanEconomicsStore.calculatedFields;

    const ltcPurchasePricePercentage = formatPercentage(leverage.loanToCost);
    const ltcConstructionBudgetHoldbackPercentage = formatPercentage(
      leverage.constructionReserve
    );
    const ARLTV = formatPercentage(calculatedFields.afterRepairLTV);

    return (
      <LoanDetailsCardSingleProperty
        store={store}
      />
    );
  }
);